export const markupCategory = function (item) {
  const urlString = `/${item.material
    .toLowerCase()
    .replace(" - ", " ")
    .replace(" / ", " ")
    .replace("&", "and")
    .replace("-", " ")
    .replace("(", "")
    .replace(")", "")
    .split(" ")
    .join("-")}/${item.category
    .toLowerCase()
    .replace(" - ", " ")
    .replace(" / ", " ")
    .replace("&", "and")
    .replace("-", " ")
    .replace("(", "")
    .replace(")", "")
    .split(" ")
    .join("-")}.html`;
  return `
<div class="category-card">
  <a href="${urlString}">
  <div class="category-card__image">
    <img src="/img/product-clean/${item.images[0]}.webp" alt="" />
  </div>
  <div class="category-card__info">
    <h2 class="category-card__title">${item.category}</h2>
    <div class="category-card__buttons">
      <span class="category-card__view-more">
        See Products
      </span>
    </div>
  </div>
  </a>
</div>
`;
};
